import React, { useMemo } from "react";
import { Card, CardBody, CardHeader } from "reactstrap";
import { useQuery } from "react-query";
import { Spin } from "antd";
import TableContainerMin from "../../../Components/Common/TableContainer";
import { getInspectionByVehId } from "../../Inspection/services/inspectionsApi";


const IncidentUser = ({ user }) => {
    
  const vehicleId = user?.vehicle?.id
  const {
    data: inspection,
    isLoading,
    isError,
    error,
  } = useQuery(["inspectionUser", vehicleId], () => getInspectionByVehId(vehicleId),
  {
    enabled: !!vehicleId,
  });

  const incident = inspection ? inspection.filter(item => item.category === "Incident") : [];
  
  const columns = useMemo(
    () => [
        { 
          Header: "Nom", 
          accessor: "revisions",
          Cell: ({ cell: { value } }) => {
            return value && value.length > 0 ? value[0]?.name : "-";
          },
          filterable: false 
        },
        { Header: "Type d'inspection", accessor: "typeInspection", filterable: false },
        { 
          Header: "Véhicule", 
          accessor: "vehicle",
          Cell: ({ cell: { value } }) => {
            return value && value.brand ? value.brand : "-";
          },
          filterable: false 
        },
        { Header: "Status", accessor: "status", filterable: false },
    ],
    []
  );

  return (
    <Card id="contactList">
      <CardHeader>
        Liste des incidents réalisés par le chauffeur {user?.name || "-"}
      </CardHeader>
      <CardBody className="pt-0">
        <TableContainerMin
          columns={columns}
          data={incident || []}
          isGlobalSearch={true}
          isGlobalFilter={true}
          customPageSize={5}
          className="custom-header-css"
          divClass="table-responsive table-card mb-3"
          tableClass="align-middle table-nowrap"
          theadClass="table-light"
        />
        {isLoading && !isError && (
          <div className="text-center">
            Chargement... <Spin />
          </div>
        )}
        {inspection && inspection.length === 0 && !isLoading && (
          <div>Erreur lors du chargement, {error || error?.message}</div>
        )}
      </CardBody>
    </Card>
  );
};

export default IncidentUser;
